<template>
  <div v-if="load">
    <div class="banner">
      <img
        class="media__image media__element b-lazy b-responsive b-loaded"
        :src="banner.cover"
        alt
        typeof="foaf:Image"
      />
    </div>
    <div class="row header-row">
      <h2 class="columns small-12 large-7 contract-us-title">
        <span>联系我们</span>
      </h2>
      <div class="columns small-12 large-5"></div>
    </div>
    <div class="row magellan-container">
      <div class="columns small-12 large-3" id="content-container"></div>
      <div class="columns small-12 large-9" id="content-container" style="margin-bottom: 2rem">
        <div>
          <div class="paragraph paragraph--type--list-group paragraph--view-mode--default">
            <h3 style="margin: 1rem 0" class="welocome">欢迎投资基金产品</h3>
            <div>
              <div
                class="paragraph clearfix constrain row paragraph--type--list-item paragraph--view-mode--default"
              >
                <h6
                  class="field columns small-6 field--name-field-paragraph-list-item-name field--type-string field--label-hidden"
                >
                  <img src="../assets/images/tel.png" alt />电话
                </h6>

                <div
                  class="field columns small-6 xlarge-5 field--name-field-list-item-note field--type-string field--label-hidden"
                  style="text-align: right"
                >
                  <h6>{{data.tel}}</h6>
                </div>
              </div>

              <div
                class="paragraph clearfix constrain row paragraph--type--list-item paragraph--view-mode--default"
              >
                <h6
                  class="field columns small-6 field--name-field-paragraph-list-item-name field--type-string field--label-hidden"
                >
                  <img src="../assets/images/email.png" alt />邮箱
                </h6>

                <div
                  style="text-align: right"
                  class="field columns small-6 xlarge-5 field--name-field-list-item-note field--type-string field--label-hidden"
                >
                  <h6>{{data.email}}</h6>
                </div>
              </div>

              <div
                class="paragraph clearfix constrain row paragraph--type--list-item paragraph--view-mode--default"
              >
                <h6
                  class="field columns small-6 field--name-field-paragraph-list-item-name field--type-string field--label-hidden"
                >
                  <img src="../assets/images/person.png" alt />服务热线
                </h6>

                <div
                  style="text-align: right"
                  class="field columns small-6 xlarge-5 field--name-field-list-item-note field--type-string field--label-hidden"
                >
                  <h6>{{data.service_tel}}</h6>
                </div>
              </div>

              <div
                class="paragraph clearfix constrain row paragraph--type--list-item paragraph--view-mode--default"
              >
                <h6
                  class="field columns small-6 field--name-field-paragraph-list-item-name field--type-string field--label-hidden"
                >
                  <img src="../assets/images/adress.png" alt />地址
                </h6>

                <div
                  style="text-align: right"
                  class="field columns small-6 xlarge-6 field--name-field-list-item-note field--type-string field--label-hidden"
                >
                  <h6>{{data.address}}</h6>
                </div>
              </div>

              <div
                class="paragraph clearfix constrain row paragraph--type--list-item paragraph--view-mode--default"
                style="border-bottom:none"
              >
                <h6
                  style="width: 100%"
                  class="field columns small-6 field--name-field-paragraph-list-item-name field--type-string field--label-hidden"
                >
                  <img src="../assets/images/qrcode.png" alt />扫码关注盛世长宏
                </h6>
              </div>
              <!-- 2 -->
              <div v-if="url">
                <img class="qrcode-img" :src="url" alt />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ContactUs, QrcodeCode } from "@/api/index";
export default {
  components: {},
  data() {
    return {
      load: false,
      data: null,
      banner: null,
      url: null,
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {
    ContactUs((res) => {
      this.load = true;
      this.$emit("complete", true);
      if (res.code == 0) {
        this.banner = res.data.banner[0];
        this.data = res.data;
      }
      setTimeout(() => {
        document
          .getElementById("footer-contactUs-link")
          .classList.add("is-active");
      }, 100);
    }),
      QrcodeCode((res) => {
        if (res.code == 0) {
          this.url = res.data.url;
        }
      });
  },
  mounted() {},
};
</script>
<style lang='less' scoped>
.banner {
  margin-bottom: 3.125rem;
  img {
    width: 100%;
    height: 43vw;
  }
}
.field--name-field-paragraph-list-item-name {
  display: flex;
  align-items: center;
  img {
    width: 22px;
    height: auto;
    margin-right: 10px;
  }
}
@media print, screen and (max-width: 40em) {
  .contract-us-title {
    font-size: 1.5rem;
  }
  .welocome {
    font-size: 1.3rem;
  }
  .qrcode-img {
    width: 40vw;
    height: auto;
  }
}
</style>